/**
 * Errores de dominio con codigo funcional estable.
 *
 * El codigo es parte del contrato publico: la API lo devuelve al cliente y la PWA
 * lo traduce a un mensaje en espanol para el usuario. Nunca se expone el stack ni
 * el mensaje tecnico a la interfaz.
 */

export const DOMAIN_ERROR_CODES = [
  // Dinero / formato
  'MONTO_INVALIDO',
  'MONTO_NO_POSITIVO',
  'MONEDA_INVALIDA',
  'MONEDA_INCONSISTENTE',
  // Pagos
  'PAGO_SIN_DISTRIBUCION',
  'DISTRIBUCION_NO_CUADRA',
  'CARGO_NO_ENCONTRADO',
  'CARGO_DE_OTRO_ESTUDIANTE',
  'CARGO_SOBREPAGADO',
  'EXCEDENTE_NO_PERMITIDO',
  'METODO_PAGO_NO_PERMITIDO',
  'REFERENCIA_REQUERIDA',
  'REFERENCIA_INVALIDA',
  'PAGO_YA_ANULADO',
  'PAGO_NO_CONFIRMADO',
  'ESTUDIANTE_INACTIVO',
  'CONCEPTO_INACTIVO',
  'CICLO_CERRADO',
  // Idempotencia / sincronizacion
  'CLAVE_IDEMPOTENTE_REUTILIZADA',
  'TRANSICION_SYNC_INVALIDA',
  'OPERACION_DEPENDIENTE_PENDIENTE',
  // Conflictos
  'CONFLICTO_VERSION',
  'CONFLICTO_REQUIERE_REVISION',
  // Numeracion / descargas
  'NUMERACION_DIA_INVALIDO',
  'NUMERACION_SIN_ASIGNACION',
  'DESCARGA_EN_CURSO',
  // Autorizacion
  'PERMISO_DENEGADO',
  'SESION_OFFLINE_EXPIRADA',
  'DISPOSITIVO_NO_AUTORIZADO',
  // Limpieza de temporales
  'TEMPORAL_NO_ELIMINABLE',
] as const;

export type DomainErrorCode = (typeof DOMAIN_ERROR_CODES)[number];

export class DomainError extends Error {
  readonly code: DomainErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(code: DomainErrorCode, message: string, details: Record<string, unknown> = {}) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    this.details = Object.freeze({ ...details });
  }
}

export function isDomainError(value: unknown): value is DomainError {
  return value instanceof DomainError;
}

/** Lanza `DomainError` si la condicion no se cumple. */
export function assertDomain(
  condition: unknown,
  code: DomainErrorCode,
  message: string,
  details: Record<string, unknown> = {},
): asserts condition {
  if (!condition) throw new DomainError(code, message, details);
}
